import { useState, useEffect } from "react";

import { InputMask } from "primereact/inputmask";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";

import CardSeplag from "./../../components/CardSeplag/index";
import TableSeplag from "../../components/TableSeplag";
import RotuloSeplag from "../../components/RotuloSeplag";

import ModalManterAmparoLegal from "./ModalManterAmparoLegal";

import { printToast, summaryExclusaoSucessoPadrao, detailExclusaoSucessoPadrao } from "../../config/global";

// service
import { pesquisarAll as pesquisarAllAmparoLegal, remover as removerAmparoLegal, buscarPersonalizada as filtrarAmparoLegal } from "../../service/ManterAmparoLegal";

import { pesquisarAll as pesquisarAllTipoAto } from "../../service/TipoAto";

import { pesquisarAll as pesquisarAllEsferaGoverno } from "../../service/EsferaGoverno";

import { pesquisarAll as pesquisarAllOrgao } from "../../service/Orgao";

const formFiltro = {
  idenEsferaGoverno: null,
  numrAto: "",
  dataPublicacaoAto: null,
  idenTipoAto: null,
  descComplementoAmparo: "",
  orgao: {
    idenOrgao: null,
  },
};

// campos da tabela
const camposTabela = [
  { titulo: "Amparo Legal", nome: "descAmparoLegal" },
  { titulo: "Órgão", nome: "descOrgao" },
  { titulo: "Data Publicação", nome: "dataPublicacaoAto" },
  // { titulo: "Data Término", nome: "dataTerminoVigencia" },
  // { titulo: "Número Ato",   nome: "numrAto"},
  // { titulo: "Ano",   nome: "numrAnoAto"},
];

const Index = () => {
  // dados pagina
  const [dataManterAmparoLegal, setDataManterAmparoLegal] = useState([]);
  const [listaOrgao, setListaOrgao] = useState([]);
  const [listaTipoAto, setListaTipoAto] = useState([]);
  const [listaEsferaGoverno, setListaEsferaGoverno] = useState([]);
  const [data, setData] = useState(formFiltro);

  // formulario
  const [form, setForm] = useState(null);
  // const [idenOrgao, setIdenOrgao] = useState();

  // estado do modal
  const [showForm, setShowForm] = useState(false);

  // edit
  const [edit, setEdit] = useState(false);

  useEffect(() => {
    pesquisarAllAmparoLegal().then((res) => {
      setDataManterAmparoLegal(res.content);
    });

    pesquisarAllOrgao().then((res) => {
      setListaOrgao(res);
    });

    pesquisarAllTipoAto().then((res3) => {
      setListaTipoAto(res3);
    });

    pesquisarAllEsferaGoverno().then((res4) => {
      setListaEsferaGoverno(res4);
    });
  }, []);

  function onAdicionarDado() {
    setForm(null);
    setEdit(false);
    setShowForm(true);
  }

  function onEditarDado(rowData) {
    rowData.esferaGoverno = rowData.siglEsferaGoverno;

    setForm(rowData);
    setShowForm(true);
    setEdit(true);
  }

  const onFiltrarAmparoLegal = async () => {
    let rowData = {
      idenEsferaGoverno: data.idenEsferaGoverno,
      numrAto: data.numrAto,
      dataPublicacaoAto: data.dataPublicacaoAto,
      idenTipoAto: data.idenTipoAto,
      orgao: {
        idenOrgao: data.orgao.idenOrgao,
      },
    };

    if (rowData) {
      await filtrarAmparoLegal(rowData).then((res) => {
        setDataManterAmparoLegal(res.content);
      });
    } else {
      pesquisarAllAmparoLegal().then((res) => {
        setDataManterAmparoLegal(res.content);
      });
    }
  };

  function onExcluirDado(rowData) {
    removerAmparoLegal(rowData).then(() => {
      setTimeout(() => {
        pesquisarAllAmparoLegal().then((res) => {
          setDataManterAmparoLegal(res.content);
          printToast({ summary: summaryExclusaoSucessoPadrao, detail: detailExclusaoSucessoPadrao });
        });
      });
    });
  }

  const handleClear = () => {
    pesquisarAllAmparoLegal().then((res) => {
      setDataManterAmparoLegal(res.content);
    });
    setData(formFiltro);
  };

  return (
    <CardSeplag title="Amparo Legal">
      <div className="p-grid p-col-12 p-md-12">
        <RotuloSeplag nome="Tipo do Ato:" cols="12 4">
          <Dropdown filter style={{ width: "100%" }} optionLabel="descTipoAto" optionValue="idenTipoAto" id="idenTipoAto" value={data?.idenTipoAto} showClear onChange={(e) => setData({ ...data, idenTipoAto: e.value })} options={listaTipoAto} placeholder="Selecione..." />
        </RotuloSeplag>
        <RotuloSeplag nome="Nº Ato:" cols="12 4">
          <InputText id="numrAto" style={{ width: "100%" }} name="numrAto" value={data.numrAto} onChange={(e) => setData({ ...data, numrAto: e.target.value })} />
        </RotuloSeplag>
        <RotuloSeplag nome="Data Publicação:" cols="12 4">
          <InputMask mask="99/99/9999" style={{ width: "100%" }} placeholder="Data" value={data?.dataPublicacaoAto} onChange={(e) => setData({ ...data, dataPublicacaoAto: e.value })} />
        </RotuloSeplag>

        <RotuloSeplag nome="Orgão:" cols="12 4">
          <Dropdown filter style={{ width: "100%" }} optionLabel="descOrgao" optionValue="idenOrgao" id="idenOrgao" value={data?.orgao.idenOrgao} showClear onChange={(e) => setData({ ...data, orgao: { ...data.orgao, idenOrgao: e.value } })} options={listaOrgao} placeholder="Selecione..." />
        </RotuloSeplag>
        <RotuloSeplag nome="Complemento:" cols="12 4">
          <InputText value={data.descComplementoAmparo} onChange={(e) => setData({ ...data, descComplementoAmparo: e.target.value })} />
        </RotuloSeplag>
        <RotuloSeplag nome="Esfera:" cols="12 4">
          <Dropdown
            filter
            style={{ width: "100%" }}
            optionLabel="descEsferaGoverno"
            optionValue="idenEsferaGoverno"
            id="idenEsferaGoverno"
            value={data?.idenEsferaGoverno}
            showClear
            onChange={(e) => setData({ ...data, idenEsferaGoverno: e.value })}
            options={listaEsferaGoverno}
            placeholder="Selecione..."
          />
        </RotuloSeplag>

        <div className="p-col-12 p-md-3" style={{ marginTop: "10px" }}>
          <Button onClick={onFiltrarAmparoLegal} icon="pi pi-search" label="Filtrar" className="p-col" />
          {/* <Button onClick={handleClear} icon="pi pi-trash" label="Limpar" className="p-col p-ml-2"/> */}
        </div>
      </div>

      <TableSeplag hasEventoAcao camposTabela={camposTabela} dados={dataManterAmparoLegal} onAdicionarDado={onAdicionarDado} onEditarDado={(rowData) => onEditarDado(rowData)} onExcluirDado={(rowData) => onExcluirDado(rowData)} />
      {showForm && <ModalManterAmparoLegal onSalvar={onFiltrarAmparoLegal} formEdit={form} showForm={showForm} setShowForm={setShowForm} edit={edit} />}
    </CardSeplag>
  );
};

export default Index;
